// @ts-ignore
import { Md5 } from 'ts-md5/dist/md5'
import Api from './Api'
import Company from './Company'
import Model from './interface/Model'
import WebMessage from './WebMessage'

export default class RemoteEntity extends Model {
  public api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'remote_company' as string | null,
      plural: 'remote_companies' as string | null,
    },
  }

  public companies_details: any = {
    operative_one: {
      name: 'Operative One',
      url: 'https://www.operative.com',
      logo: 'operative_one-dark-bkgd@2x.png',
    },
  }

  public company: any = null

  public add_company: boolean = false

  public id: any = null

  public name: any = null

  public type: any = null

  public connection: any = null

  public remote_id: any = null

  public owner_id: any = null

  public company_id: any = null

  public status: any = 'pending'

  public requesting: boolean = false

  private hash: any = null

  public oldValues: any = null

  public calculateChecksum(): string | Int32Array {
    return Md5.hashStr(JSON.stringify({ ...this.apiData }))
  }

  public get is_dirty(): boolean {
    if (this.hash === null) return false
    return this.hash !== this.calculateChecksum()
  }

  public updateChecksum() {
    this.oldValues = JSON.parse(JSON.stringify({ ...this.apiData }))
    this.hash = this.calculateChecksum()
  }

  public get apiData(): any {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      connection: this.connection,
      remote_id: this.remote_id,
      owner_id: this.owner_id,
      company_id: this.company_id,
      status: this.status,
    }
  }

  public async approved(clb: any = null) {
    this.requesting = true
    let api = new Api()
    return await api
      .put(`remote_companies/${this.id}/add_company`, { company_id: this.company_id })
      .then(res => {
        this.requesting = false
        if (res.status === 200) {
          WebMessage.success('Company added successfully')
          this.status = 'approved'
          if (clb !== null) {
            clb(res)
          }
        } else {
          WebMessage.error('Something went wrong, please try again.')
        }
      })
  }

  public static async cacheUsedCompanies() {
    let api = new Api()
    return await api.get('remote_companies/store-used-companies')
  }
}
